import { CommonSectionIds } from '../common.models';

export const EdgeDxSectionIds = {
    BasicInfo: CommonSectionIds.BasicInfo,
    DialogActions: CommonSectionIds.DialogActions,
};
